import { ServiceStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const DailyProductionLogWizardRoute: RouteType = {
  name: "DailyProductionLog",
  path: "/workflows/daily-production-log",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Daily Production Log",
      component: () => import("./DailyProductionLogWizardHeader"),
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import("./DailyProductionLogWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Load necessary data for the production log
      const panelStore = rootStore.panelStore as ServiceStore;
      const castingMapLayoutStore = rootStore.castingMapLayoutStore as ServiceStore;
      const jobStore = rootStore.jobStore as ServiceStore;
      const productsStore = rootStore.productsStore as ServiceStore;

      await Promise.all([
        panelStore?.find(),
        castingMapLayoutStore?.find(),
        jobStore?.find(),
        productsStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for daily production log:", error);
      return false;
    }
  },
};

export default DailyProductionLogWizardRoute;